import type { TLngLat } from 'App/Map/types'

export const lngLatStringToLngLatObject = (input: TLngLat) => {
  const [lng, lat] = input
    .replace(/[^\d.-\s]/g, '')
    .split(' ')
    .map(Number)

  return { lng, lat }
}
